if (!customElements.get('details-modal')) {
  class DetailsModal extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');
      this.hasOpenedOnce = false;
  
      // toggle listener separato per questa istanza
      this.detailsContainer.addEventListener('toggle', () => {
        if (this.isOpen()) {
          this.onOpen();
          this.hasOpenedOnce = true;
        } else if (this.hasOpenedOnce) {
          this.onClose();
        }
        // this.isOpen() ? this.onOpen() : this.onClose();
      });
  
      this.detailsContainer.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
  
      this.summaryToggle.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );
  
      this.querySelector('button[type="button"]').addEventListener(
        'click',
        this.close.bind(this)
      );
  
      this.summaryToggle.setAttribute('role', 'button');
    }
  
    isOpen() {
      return this.detailsContainer.hasAttribute('open');
    }
  
    onOpen() {
      document.body.classList.add('overflow-hidden');
      this.detailsContainer.classList.remove('closing');
      this.onBodyClickEvent = this.onBodyClick.bind(this);
      document.body.addEventListener('click', this.onBodyClickEvent);
  
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }
  
    onClose() {
      document.body.classList.remove('overflow-hidden');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      removeTrapFocus(this.summaryToggle);

      if (this.hasOpenedOnce) {
        this.detailsContainer.classList.add('closing');
        setTimeout(() => {
          this.detailsContainer.classList.remove('closing');
        }, 200); // animation of the closing duration (in k7records.css)
      }
    }
  
    onSummaryClick(event) {
      // event.preventDefault();
      // event.target.closest('details').hasAttribute('open')
      //   ? this.close()
      //   : this.open(event);
    }
  
    onBodyClick(event) {
      // if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
      if (
        !this.contains(event.target) ||
        event.target.classList.contains('modal-overlay')
      ) {
        this.close(false);
      }
    }
  
    open(event) {
      // this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      this.onBodyClickEvent = this.onBodyClick.bind(this);
      event.target.closest('details').setAttribute('open', true);
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');
  
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }
  
    close(focusToggle = true) {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
    }
  }
  customElements.define('details-modal', DetailsModal);
}
